import { request } from '../request'

// 获取任务列表
export interface TaskListProps {
  //  安全域
  areaName?: string[]
  createTimeEnd?: string
  createTimeStart?: string
  //  任务分组
  groupId?: string
  //  每页几条
  limit?: number
  //  第几页
  page?: number
  //  任务名称/客户端名称
  search?: string
  //  任务状态
  //  TaskResultStatusWaiting: 等待中
  //  TaskResultStatusProcessing: 进行中
  //  TaskResultStatusFinished: 已完成
  //  TaskResultStatusInterrupted: 已中断
  //  TaskResultStatusStopping: 停止中
  taskStatus?: string[]
  //  验证类型
  //  VerificationTypeOnline: 在线验证
  //  VerificationTypeOffline: 离线验证
  verificationType?: string
  [property: string]: any
}
export const getResultList = (data: TaskListProps) =>
  request('/portal/v1/endpoint_security/tasks', {
    params: {
      ...data,
    },
  })

//  子任务删除
export interface DeleteList {
  result_id_list: string[]
}
export const deleteList = (data: DeleteList) =>
  request('/portal/verify/endpointSecurity/batchDeleteResult', {
    method: 'delete',
    data,
  })

// 获取安全域列表
export const getBizAreaList = () => request('/portal/verify/endpointSecurity/resultBizAreaList')

//停止任务
export const stopTask = data =>
  request('/portal/v1/endpoint_security/task/stopTask', {
    method: 'post',
    data,
  })

// 任务复测
export interface RetestProps {
  //  用例状态
  case_status?: TaskCaseStatus[]
  //  结果ID
  result_id?: string
  //  任务名称
  result_name?: string
  [property: string]: any
}

enum TaskCaseStatus {
  CaseStatusAlert = 'CaseStatusAlert', // 有告警
  CaseStatusCancelValid = 'CaseStatusCancelValid', // 取消验证
  CaseStatusExecFailure = 'CaseStatusExecFailure', // 执行失败
  CaseStatusExecSuccess = 'CaseStatusExecSuccess', // 执行成功(拦截失败+拦截成功+取消验证)
  CaseStatusInterceptionFailure = 'CaseStatusInterceptionFailure', // 拦截失败
  CaseStatusInterceptionSuccess = 'CaseStatusInterceptionSuccess', // 拦截成功
  CaseStatusNotAlert = 'CaseStatusNotAlert', // 无告警
}

export const retestTask = data =>
  request('/portal/verify/endpointSecurity/taskReExec', {
    method: 'post',
    data,
  })

// 获取任务详情用例状态列表
export const getTaskDetailUseCaseStatus = data =>
  request(`/portal/v1/endpoint_security/task_results/${data.resultId}/case`)

// 任务结果 根据用例状态统计用例数
export const getTaskDetailUseCaseCount = data =>
  request(`/portal/v1/endpoint_security/task_results/${data.resultId}/case/count`, {
    params: {
      ...data,
    },
  })

// 获取分组列表 (筛选)
export const getGroupList = () => request('/portal/v1/endpoint_security/task_results/group_list')

// 获取任务执行列表
export const getTaskExecList = (id: string, data: TaskListProps) =>
  request(`/portal/v1/endpoint_security/tasks/${id}/results`, {
    params: {
      ...data,
    },
  })

// 任务复测-获取任务详情用例状态列表
export const getTaskCaseStatusList = (id: string) =>
  request(`/portal/v1/endpoint_security/task_results/${id}/case`)

// 任务复测-根据用例状态统计用例数量
export const getTaskCaseCount = (id: string) =>
  request(`/portal/v1/endpoint_security/task_results/${id}/case/count`)

// 获取任务详情
export const getTaskDetail = (id: string) =>
  request(`/portal/v1/endpoint_security/task_detail/${id}`)

export interface CreateOfflineResultProps {
  fileId?: string
  taskResultName?: string
}
// 创建离线任务结果
export const createOfflineResult = (id: string, data: CreateOfflineResultProps) =>
  request(`/portal/v1/endpoint_security/task/${id}/create_offline_result`, {
    method: 'post',
    data,
  })

// 下载离线验证包
export const downloadOfflinePackage = (id: string) =>
  request(`/portal/v1/endpoint_security/task/${id}/download_offline_package`, {
    timeout: 1800000,
    responseType: 'blob',
  })

// 主任务删除
export const deleteTask = (taskIds: string[]) =>
  request(`/portal/v1/endpoint_security/tasks`, { method: 'post', data: { taskIds } })

// 获取任务基础信息
export const getTaskBaseInfo = (id: string) => request(`/portal/v1/endpoint_security/tasks/${id}`)

// 导入离线验证结果
export const importOfflineResult = (data: { fileId: string }) =>
  request(`/portal/v1/endpoint_security/task/import_offline_result_package`, {
    method: 'post',
    data,
    timeout: 60000,
  })

// 获取所有任务关联安全设备列表
export const getTaskDeviceList = () => request(`/portal/v1/endpoint_security/task/deviceList`)

// 主任务关联模板列表
export const getTaskTemplateList = (
  id: string,
  data: { page?: number; pageSize?: number; sortOrder?: string },
) =>
  request(`/portal/v1/endpoint_security/tasks/${id}/templateList`, {
    params: {
      ...data,
    },
  })

export interface TemplateCaseListProps {
  attackTypeId?: string[]
  page?: number
  pageSize?: number
  resourceName?: string
  riskLevel?: string[]
  resourceLevel?: string[]
  sortField?: string
  sortOrder?: string
  [property: string]: any
}

// 主任务关联模板的用例列表
export const getTaskTemplateCaseList = (
  id: string,
  templateId: string,
  data: TemplateCaseListProps,
) =>
  request(`/portal/v1/endpoint_security/tasks/${id}/template/${templateId}/caseList`, {
    params: {
      ...data,
    },
  })

// 主任务关联模板的用例列表的攻击类型
export const getTaskTemplateCaseListAttackType = (id: string, templateId: string) =>
  request(`/portal/v1/endpoint_security/tasks/${id}/template/${templateId}/caseAttackList`)

// host列表筛选框
export const getHostList = () => request(`/portal/v1/endpoint_security/host/list`)

// 暂停主任务
export const pauseTask = (id: string) =>
  request(`/portal/v1/endpoint_security/task/pause`, {
    method: 'post',
    data: {
      taskId: id,
    },
  })

// 开启主任务
export const startTask = (id: string) =>
  request(`/portal/v1/endpoint_security/task/start`, {
    method: 'post',
    data: {
      taskId: id,
    },
  })
